
import router from '@/router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style

import { getToken } from '@/helpers/auth' // get token from cookie
import { SessionStorage } from '@/helpers/storage'
import Constant from '@/utils/constant'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login', '/404', '/ckContent'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  // console.log(to, from)

  // 区分主题
  const currProgramType = store.getters.currCustomer.programType
  // console.log(currProgramType)
  const theme = Constant.tp_list.indexOf(currProgramType) > -1 ? 'tp' : 'nt'
  window.document.documentElement.setAttribute('data-theme', theme)
  SessionStorage.setItem('data-theme', theme)
  store.dispatch('apps/SET_THEME', theme)

  // start progress bar
  NProgress.start()

  // determine whether the user has logged in
  const hasToken = getToken()
  // console.log('------hasToken---', to.path, hasToken)

  if (!hasToken || hasToken === process.env.VUE_APP_TOKEN) {
    /* has no token */

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }

    return
  }

  /* has token */
  // if (to.path === '/login') {
  //   // if is logged in, redirect to the home page
  //   next({ path: '/' })
  //   NProgress.done()
  // } else {
  //   next()
  // }
  next()
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
